// The laundrette's walls, in the town's (x, z), written by scripts/blender/laundrette.py from where Sam placed it in
// Kiwi_world.blend. Do not edit: run the script again. Boxes in the building's own axes: its brick walls with gaps
// at the front door and the office door, and the things in the way (the machines, benches, table, counter, shelves
// and bins; the roof stands out past the walls, so he can stand under it at the door). As tall as the roof, so the
// chase camera keeps out of them too. Read by components/three/obstacles/ObstacleProvider.jsx, which sends them to
// the town with the rest.

export const LAUNDRETTE_BLOCKS = [
  {"name":"laundrette_wall","cx":60.066,"cz":-107.271,"hx":0.225,"hz":10.77,"ax":[0.318,0.948]},
  {"name":"laundrette_wall","cx":52.378,"cz":-96.72,"hx":7.335,"hz":0.128,"ax":[0.318,0.948]},
  {"name":"laundrette_wall","cx":72.56,"cz":-103.486,"hx":7.335,"hz":0.128,"ax":[0.318,0.948]},
  {"name":"laundrette_wall","cx":58.566,"cz":-91.217,"hx":0.15,"hz":3.99,"ax":[0.318,0.948]},
  {"name":"laundrette_wall","cx":69.624,"cz":-94.923,"hx":0.15,"hz":5.378,"ax":[0.318,0.948]},
  {"name":"laundrette_wall","cx":58.438,"cz":-100.848,"hx":1.418,"hz":0.165,"ax":[0.318,0.948]},
  {"name":"laundrette_wall","cx":60.36,"cz":-95.116,"hx":2.978,"hz":0.165,"ax":[0.318,0.948]},
  {"name":"laundrette_wall","cx":64.791,"cz":-104.338,"hx":0.128,"hz":6.968,"ax":[0.318,0.948]},
  {"name":"laundrette_things","cx":50.775,"cz":-99.164,"hx":1.86,"hz":0.853,"ax":[0.318,0.948]},
  {"name":"laundrette_things","cx":53.9,"cz":-94.592,"hx":2.339,"hz":0.632,"ax":[0.318,0.948]},
  {"name":"laundrette_things","cx":52.108,"cz":-99.461,"hx":1.447,"hz":0.471,"ax":[0.318,0.948]},
  {"name":"laundrette_things","cx":56.539,"cz":-95.476,"hx":2.339,"hz":0.632,"ax":[0.318,0.948]},
  {"name":"laundrette_things","cx":60.861,"cz":-91.325,"hx":0.473,"hz":1.325,"ax":[0.318,0.948]},
  {"name":"laundrette_things","cx":60.137,"cz":-94.498,"hx":2.45,"hz":0.901,"ax":[0.318,0.948]},
  {"name":"laundrette_things","cx":57.769,"cz":-100.892,"hx":0.89,"hz":0.435,"ax":[0.318,0.948]},
  {"name":"laundrette_things","cx":60.438,"cz":-94.886,"hx":2.179,"hz":0.508,"ax":[0.318,0.948]},
  {"name":"laundrette_things","cx":59.253,"cz":-101.024,"hx":1.211,"hz":0.676,"ax":[0.318,0.948]},
  {"name":"laundrette_things","cx":65.695,"cz":-105.152,"hx":0.703,"hz":5.877,"ax":[0.318,0.948]},
  {"name":"laundrette_things","cx":66.564,"cz":-99.778,"hx":1.331,"hz":3.665,"ax":[0.318,0.948]},
  {"name":"laundrette_things","cx":68.345,"cz":-95.343,"hx":0.52,"hz":3.429,"ax":[0.318,0.948]},
  {"name":"laundrette_things","cx":65.422,"cz":-108.369,"hx":0.447,"hz":4.769,"ax":[0.318,0.948]},
  {"name":"laundrette_things","cx":72.817,"cz":-100.305,"hx":3.835,"hz":0.66,"ax":[0.318,0.948]},
]
export const LAUNDRETTE_HEIGHT = 7.48

export function laundretteBlocks() {
  return LAUNDRETTE_BLOCKS
}

// The doors that swing open as a visitor or he comes near (components/three/world/Laundrette.jsx): the model's
// nodes for it, standing on its hinge, the middle of its doorway, and how far it turns round the up axis to open,
// in radians.
export const LAUNDRETTE_DOORS = [
  {"name":"front","nodes":["laundrette_door_front","laundrette_door_front_glass"],"x":63.463,"z":-92.727,"open":1.571},
  {"name":"office","nodes":["laundrette_door_office"],"x":59.155,"z":-98.699,"open":1.571},
]

// Where Sam put the building, in the town's terms: things placed in the pack's own units (Blender's x, y, z up)
// go in a group with this (components/three/world/LaundretteThings.jsx). The town's (x, y, z) is the pack's
// (x, z, -y), turned round the up axis by rotY and scaled.
export const LAUNDRETTE_ROOT = {"x":62.398,"z":-100.316,"rotY":-1.24735,"scale":1.5}
